import React, { useEffect } from "react";
import { Container, Typography, Box } from "@mui/material";
import AppAppBar from "../homePage/AppAppBar";
import Footer from "../homePage/Footer";
import "./Privacy.css";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const textColor = theme.palette.mode === "dark" ? "white" : "black";
  
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <>
      <AppAppBar showSubMenu={false} />
      <Container
        className="container"
        sx={{
          mt: { xs: 8, md: 10 },
          px: { xs: 2, md: 0 },
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box
          className="box"
          sx={{
            mt: 1,
            px: { xs: 2, md: 0 },
            height: "calc(100vh - 200px)",
            overflowY: "auto",
            paddingRight: "1rem",
          }}
        >
          <Typography
            sx={{
              fontSize: "24px",
              fontFamily: "montserrat, sans-serif",
              color: textColor,
              fontWeight: "bold",
            }}
          >
            Privacy Policy
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            Customer's privacy is very important to NEXENSUS. NEXENSUS wouldn't
            let any information shared with it to go to the public/ any other
            unauthorized person/ organization or people and/or allow any misuse
            of the said information. NEXENSUS undertakes that any information
            that NEXENSUS or its affiliates collect will only be used in ways
            for which the Customer has consented and authorized. NEXENSUS uses
            outside credit card processing Companies to bill the Customer for
            the Software and the services, these Companies have represented to
            the NEXENSUS and its affiliates that they do not retain, share,
            store or use personally identifiable information for any secondary
            purposes beyond filling the Customer's Order. The Customer
            understands that NEXENSUS and its affiliates, partner with other
            parties to provide specific services and when the Customer
            signs/authorizes for these services, NEXENSUS will share names, or
            other contact information that is necessary for the third party to
            provide these services. However, these parties are not allowed to
            use personally identifiable information except for the purpose of
            providing these services.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            NEXENSUS website/URLs contain links to other sites. Please be aware
            that NEXENSUS or its affiliates are not responsible for the content
            or privacy practices of such other sites. NEXENSUS cautions and
            encourages the Customer to be aware when they leave NEXENSUS site
            and to read the privacy policy of the use of such link. NEXENSUS in
            no any manner, whatsoever, shall be responsible for any breach of
            privacy by such link/other site.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            Each party may have access to and may become acquainted with various
            information and other property of the other party, including but not
            limited to publicly available information or specific non-public
            information, modus operandi, core business interest, core area of
            business and clients, reports, drawings, schematics, prototypes,
            models, devices or inventions (whether or not patented or
            patentable, copyrighted or copyrightable), financial information,
            business plans, marketing information, sales plans, cost
            information, customer information, price lists, and intellectual
            property (e.g., the Software, which shall be deemed NEXENSUS's
            Confidential Information), all of which are owned by such other
            party and/or are regularly used in the operation of such other
            party's business (hereinafter "Confidential Information").
            Confidential Information includes information that is conspicuously
            marked "Confidential," "Copyrights and other Proprietary Rights,"
            "Intellectual Property Rights", "Restriction on Use" clauses in the
            Software License Agreement (the "Agreement"), or the like and/or
            information that the receiving party should reasonably understand as
            being confidential or proprietary to the disclosing party. However,
            the obligations set forth in this clause shall not apply to the
            extent that the other party's Confidential Information is required
            to be disclosed by or under provision of any Law or valid order of a
            Court or other governmental Authority; provided that the responding
            party agrees to deliver reasonable notice to the other party and use
            commercially reasonable efforts to cooperate with such other party's
            attempt to obtain a protective order. Each party shall use the other
            party's Confidential Information only in connection with the
            performance of its obligations and exercise of its rights as
            described in an Order and no party shall sell, trade or
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            otherwise transfer such information. Neither party shall disclose
            the other party's Confidential Information to any third party,
            except to its affiliates, subcontractors, agents, attorneys, and
            advisors who have a need to receive it and who have written or
            ethical obligations that serve to protect it in a manner no less
            restrictively than as set forth herein. Each party will use the same
            degree of care that it uses with respect to its own Confidential
            Information (but in no event less than reasonable care) to maintain
            in confidence except as permitted herein, any Confidential
            Information of the other party.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            By using NEXENSUS websites/URLs, the Customer agrees, authorizes and
            gives consent to the terms set out herein in this Privacy Policy.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            This policy came into effect and was latest updated on the 19th day
            of December, 2014.
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "15px", fontFamily: "Arial, sans-serif" }}
            gutterBottom
          >
            INFORMATION COLLECTED FROM WEBSITE VISITORS/CUSTOMERS
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            NEXENSUS and its affiliates are the sole owners of the information
            collected when the Customer visits a NEXENSUS website/URL etc.
            NEXENSUS only has access to/collect information that the Customer
            voluntarily gives it via email or other direct contact with
            NEXENSUS. Customer's activity, browser information and information
            about the referring site, along with an approximation of its
            location may be recorded.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            NEXENSUS uses this information to fulfill the Order, supply the
            requested information, personalize the Customer's experience as the
            Customer's information helps NEXENSUS to better respond to the
            Customer's individual needs, improve its websites as NEXENSUS
            continuously strives to improve its website/services offerings
            (based on the information and feedback NEXENSUS receives from the
            Customer), products and services and the Customer's experience with
            NEXENSUS as the Customer's information helps NEXENSUS to more
            effectively respond to the Customer's service requests and support
            needs. Unless the Customer asks NEXENSUS not to, NEXENSUS may
            contact the Customer via email in the future to tell the Customer
            about specials, new products or services or changes to this privacy
            policy. NEXENSUS or its Affiliates will not share this personally
            identifiable information with a third party other than to fulfill
            the Customer's request or in the circumstances set out below.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            Notwithstanding anything contained in this Privacy Policy the
            Customer understands and NEXENSUS has made it clear to the Customer
            that when required by law (under Court order, governmental order,
            warrant or subpoena), or when NEXENSUS believes that disclosure is
            reasonably necessary to protect the rights of NEXENSUS or third
            parties, personally identifiable information may be disclosed,
            limited to the extent of such an obligation of NEXENSUS to the
            lawful authority/authorities.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            The Customer understands that the NEXENSUS reserves its right to
            publish correspondence and feedback sent to NEXENSUS in order to
            help it respond to the correspondence or to help other users.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            NEXENSUS will take all reasonable measures to protect against
            unauthorized access, use and alteration to personally identifiable
            information. When passing
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            personally identifiable information to a third party, NEXENSUS will
            ensure that reasonable and adequate protection of the information is
            applied by the recipient.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            Should NEXENSUS or its Affiliates, be acquired or merged with
            another organization, the information the Customer has shared with
            NEXENSUS or the previous history of searches/information used may be
            transferred. NEXENSUS will notify the Customer if Customer's
            information is to be subject to a different privacy policy.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            Should NEXENSUS cease trading or file for bankruptcy, information
            held about the Customer will not be transferred to a third party.
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "15px", fontFamily: "Arial, sans-serif" }}
            gutterBottom
          >
            CREDIT CARD INFORMATION
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            Customer's transaction may be processed by one of NEXENSUS's
            third-party payment vendors, if the payment is not being made
            through Cheque or Demand Draft. These vendors are payment processors
            who can process the Customer's payment on behalf of NEXENSUS. The
            vendor which will be used to process the Customer's own transaction
            will depend on the kind of services or subscription the Customer
            wishes or mutually agreed upon.
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "15px", fontFamily: "Arial, sans-serif" }}
            gutterBottom
          >
            COOKIES
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            A cookie is a small amount of information that NEXENSUS's websites
            can store on Customer's computer. Customer's computer provides this
            cookie when visiting the same website in the future. Cookies are
            used to enhance Customer's experience with a website.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            NEXENSUS uses cookies to identify visitors and track visits to its
            website, store login session information and to remember the
            Customer's user preferences.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            Customer can disable the storage of cookies in its web browser, but
            should be aware that doing so may affect the quality of the
            experience with the website. In some cases, the website may not work
            at all. The Customer's sole discretion is required in this behalf
            and NEXENSUS shall not be responsible for any such inability to use
            the services.
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "15px", fontFamily: "Arial, sans-serif" }}
            gutterBottom
          >
            CONTACTING NEXENSUS
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            The Customer may contact NEXENSUS using any of the methods outlined
            here:
            <div>
              <a
                href="https://www.nexensus.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visit Nexensus (www.nexensus.com)
              </a>
            </div>
            NEXENSUS's mailing address is: NEXENSUS C/o EAGLE PEAK INTEL.
            PRIVATE LIMITED A 223, SOMDUTT CHAMBERS I, BHIKAJI CAMA PLACE NEW
            DELHI-110066 INDIA
          </Typography>
          <Typography
            variant="h4"
            sx={{ fontSize: "15px", fontFamily: "Arial, sans-serif" }}
            gutterBottom
          >
            CHANGES TO THIS POLICY
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontSize: "13px", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            From time to time NEXENSUS may make adjustments to this privacy
            policy. Changes to this policy will be made at NEXENSUS's sole
            discretion. NEXENSUS's users/Customers are encouraged to check this
            privacy policy for such changes. Customers continued use of this
            site post any such change(s) to this privacy policy constitutes
            Customer's unequivocal and absolute acceptance of the changes.
          </Typography>
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", fontFamily: "montserrat, sans-serif" }}
            gutterBottom
          >
            If the Customer feels that NEXENSUS or its affiliates are not
            abiding by this privacy policy, the Customer should contact NEXENSUS
            immediately via telephone at +91-9205685050 or via email -
            <a href="mailto:info@nexensus.com?subject=Subject%20Here&body=Body%20text%20here">
              info@nexensus.com
            </a>
          </Typography>
          <br />
        </Box>
      </Container>
      <AppAppBar
        showSubMenu={false}
        showPricing={true}
        showContactUs={true}
        showTermsofService={true}
      />
      <Footer />
    </>
  );
};

export default Privacy;
